__turbopack_context__.v({
  "buyMetaStack": "wD17sa_buyMetaStack",
  "buySection": "wD17sa_buySection",
  "disclaimerButton": "wD17sa_disclaimerButton",
  "disclaimerButtonContainer": "wD17sa_disclaimerButtonContainer",
  "heightOpacityIn": "wD17sa_heightOpacityIn",
  "largePrompt": "wD17sa_largePrompt",
  "learnMoreButton": "wD17sa_learnMoreButton",
  "leftPanel": "wD17sa_leftPanel",
  "mobileCarouselSection": "wD17sa_mobileCarouselSection",
  "notServicableMessageContainer": "wD17sa_notServicableMessageContainer",
  "powerPlugSubsection": "wD17sa_powerPlugSubsection",
  "priceContentContainer": "wD17sa_priceContentContainer",
  "rightPanel": "wD17sa_rightPanel",
  "root": "wD17sa_root",
  "section": "wD17sa_section",
  "separator": "wD17sa_separator",
  "sizeInfoModal": "wD17sa_sizeInfoModal",
  "stickyPanel": "wD17sa_stickyPanel",
});
